import React from 'react';

const PanelSize = (props) => {
  const { parameters } = props;
  const {
    panel_size_x,
    panel_size_y,
  } = parameters;

  return (
    <div className="alert alert-info" role="alert">
      Approximate panel size: {panel_size_x} x {panel_size_y} (inches)
    </div>
  );
};

export default PanelSize;